import { render, staticRenderFns } from "./DecisionModelo.vue?vue&type=template&id=5c6fa9e5&scoped=true"
import script from "./DecisionModelo.vue?vue&type=script&lang=js"
export * from "./DecisionModelo.vue?vue&type=script&lang=js"
import style0 from "./DecisionModelo.vue?vue&type=style&index=0&id=5c6fa9e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6fa9e5",
  null
  
)

export default component.exports